import { jsx as _jsx } from "react/jsx-runtime";
import { sourceKeys } from 'ui-addon-upgrades/_core/common/data/upgradeData/properties/sources';
import CheckoutButton from 'ui-addon-upgrades/_core/checkout/CheckoutButton';
import MultipleOfferCheckoutButton from '../_core/checkout/MultipleOfferCheckoutButton';
import validateUpgradeData from '../_core/common/data/upgradeData/validateUpgradeData';
import { MARKETING_STARTER, MARKETING_STARTER_EMAIL, GENERAL } from 'self-service-api/constants/UpgradeProducts';
import { getSource } from 'ui-addon-upgrades/_core/common/data/upgradeData/transformers/getPropertySource';
import { mapPurchaseMotionApiName } from '../ums/utils';
const {
  CHECKOUT
} = sourceKeys;

const UICheckoutButton = props => {
  const {
    offerProductConfigurations,
    nonRecurringProductConfigurations,
    productConfigurations,
    upgradeData,
    canViewNewSeats
  } = props;
  const upgradeDataWithApiName = Object.assign({}, upgradeData, {
    apiName: mapPurchaseMotionApiName(canViewNewSeats, upgradeData.upgradeProduct, 'UICheckoutButton', upgradeData.apiName)
  });
  const isValid = validateUpgradeData(upgradeData);
  const {
    app,
    screen,
    uniqueId,
    upgradeProduct,
    upgradeKey
  } = upgradeDataWithApiName;
  const correctedUpgradeProduct = isValid ? upgradeProduct === MARKETING_STARTER ? MARKETING_STARTER_EMAIL : upgradeProduct : GENERAL; // Per discussion with Liana: https://hubspot.slack.com/archives/CC04HSNNQ/p1682102540191569?thread_ts=1681323565.204229&cid=CC04HSNNQ

  const source = upgradeKey || getSource({
    app,
    screen,
    uniqueId
  }, CHECKOUT);
  const correctedUpgradeData = Object.assign({}, upgradeDataWithApiName, {
    upgradeProduct: correctedUpgradeProduct,
    source
  });
  const correctedProps = Object.assign({}, props, {
    upgradeData: correctedUpgradeData
  });

  if (offerProductConfigurations && nonRecurringProductConfigurations && !productConfigurations) {
    return /*#__PURE__*/_jsx(MultipleOfferCheckoutButton, Object.assign({}, correctedProps));
  }

  return /*#__PURE__*/_jsx(CheckoutButton, Object.assign({}, correctedProps));
};

export default UICheckoutButton;